export const SummaryServiceImplFactory = ({
  summaryRepository,
}: {
  summaryRepository: ISummaryRepository;
}) => {
  const getSummaryService: IGetSummaryService = async (payload) => {
    try {
      const response = await summaryRepository.getSummaryAPI({
        clinic_id: payload.clinicId,
        floor_ids: payload.floorIds,
        timezone: payload.timezone,
      });

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getSummaryService,
  };
};
